import { useState } from 'react';

interface Props {
  typeId: string;
  typeName: string;
  onGenerate: (typeId: string, startDate: string, endDate: string) => Promise<number>;
  onClose: () => void;
}

export default function GenerateEventsModal({ typeId, typeName, onGenerate, onClose }: Props) {
  const today = new Date().toISOString().split('T')[0];
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [result, setResult] = useState<number | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!startDate || !endDate) return;
    setIsSubmitting(true);
    setError(null);
    try {
      const count = await onGenerate(typeId, startDate, endDate);
      setResult(count);
    } catch {
      setError('Falha ao gerar eventos');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
      <div className="bg-[#111118] border border-white/10 rounded-2xl p-6 w-full max-w-sm">
        <h2 className="text-lg font-semibold text-white mb-1">Gerar Eventos</h2>
        <p className="text-sm text-white/40 mb-4">{typeName}</p>

        {result !== null ? (
          <div className="text-center py-4">
            <p className="text-2xl font-bold text-[#C8A96E] mb-1">{result}</p>
            <p className="text-sm text-white/60">eventos criados</p>
            <button
              onClick={onClose}
              className="mt-6 w-full py-2.5 bg-[#C8A96E] text-[#0A0A0F] font-semibold rounded-xl text-sm"
            >
              Fechar
            </button>
          </div>
        ) : (
          <>
            {error && (
              <div className="mb-4 p-3 bg-red-500/10 border border-red-500/20 text-red-400 rounded-xl text-sm">
                {error}
              </div>
            )}
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-xs text-white/40 mb-1">Data inicial</label>
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  className="w-full bg-white/5 border border-white/10 rounded-xl px-3 py-2 text-white text-sm outline-none focus:border-[#C8A96E]/50"
                  required
                />
              </div>
              <div>
                <label className="block text-xs text-white/40 mb-1">Data final</label>
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  min={startDate}
                  className="w-full bg-white/5 border border-white/10 rounded-xl px-3 py-2 text-white text-sm outline-none focus:border-[#C8A96E]/50"
                  required
                />
              </div>
              <div className="flex gap-3">
                <button
                  type="button"
                  onClick={onClose}
                  className="flex-1 py-2.5 border border-white/10 text-white/60 hover:text-white rounded-xl text-sm transition-colors"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="flex-1 py-2.5 bg-[#C8A96E] text-[#0A0A0F] font-semibold rounded-xl text-sm disabled:opacity-50"
                >
                  {isSubmitting ? 'Gerando...' : 'Gerar'}
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
